export default __webpack_public_path__ + "static/bcorp-logo-black-abb0ddca0533e47805f2d0525a682677.svg";